export default "__VITE_ASSET__e434ac52__"